export const parseDate = (d: string) => {
    if (!d) return 0;
    const [ month, day, year ] = d.split('/');
    const fullYear = Number(year.length === 2 ? `20${year}` : year);
    return new Date(fullYear, Number(month) - 1, Number(day));
};